import axios from "axios";

export default {
    fetchGallery() {
        return axios.get("/api/description.json?" + new Date()).then(response => response.data)
    },
    fetchVideos() {
        return axios.get("/api/videos.json?" + new Date()).then(response => response.data)
    },
    fetchGifts() {
        return axios.get("/api/gifts.json?" + new Date()).then(response => response.data)
    }
}